import { registerComponent } from '@gig/magic-common';
import PaymentTransactionsComponent from './payment.vue.js';

var PaymentTransactions = registerComponent(PaymentTransactionsComponent);

export { PaymentTransactions };
